import {styled} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";

export const StyledGrid = styled(DataGrid)(() => ({
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  backdropFilter: 'blur(24px)',
  width: '100%',
  maxWidth: '1000px',
  maxHeight: '700px',
  fontSize: '14px',
  fontFamily: 'Pretendard, sans - serif',
  fontWeight: 500,

  "& .checked": {
    color: "#AAAAAA",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
}))